/**
 *
 * @name script
 * @author MohammedSaleem
 * @fileOverview generic script that links different css functionality across aplication,
 * viz on-button-click,popup.
 */

import $ from 'jquery'

$(document).ready(function () {
   let parentEle = $('body');
   const fun = {
      dropDown: function () {
         parentEle.on('click', '.drop-down .head', function (e) {
            e.stopPropagation();

            if (!$(this).parent().hasClass('disabled')) {
               if (!$(this).parent().hasClass('open')) {
                  $('.drop-down .list, .multiSelect .list').slideUp(200);
                  $('.drop-down .head, .multiSelect .head').data({
                     'init': '0',
                  });
                  $('.drop-down').removeClass('open');
                  $('.multiSelect').removeClass('open');

                  $(this).parents().eq(0).addClass('open');
                  $(this).parents().eq(0).find('.list').slideDown(200);
                  $(this).data({
                     'init': '1',
                  });
               } else {
                  $(this).parents().eq(0).find('.list').slideUp(200);
                  let ele = $(this);
                  setTimeout(function () {
                     ele.parents().eq(0).removeClass('open');
                  }, 200);
               }
            }
         });
         parentEle.on('click', '.drop-down:not(.multi-select) .list li', function (e) {
            $(this).parent().slideUp(200);

            let ele = $(this);
            setTimeout(function () {
               ele.parents().eq(1).removeClass('open');
            }, 200);
         });

      },
      popup: function (btn, popup) {
         parentEle.on('click', btn, function (e) {
            e.stopPropagation();
            $(popup).parent().append('<div class="background"></div>');
            setTimeout(() => {
               $('.background').fadeIn(300);
               $('.popup').fadeOut(0);
               $(popup).fadeIn(300);
               $('body,html').scrollTop(0);
            }, 100)
         });

         parentEle.on('click', '.popup .close', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.popup').fadeOut(300);
            $('.background').fadeOut(300);
            setTimeout(() => {
               $('.background').remove();
            }, 400)
         });
      },
      accordion: function () {
         parentEle.on('click', '.accordion-sec .accordion-head',
             function (e) {
                e.stopPropagation();
                if ($(this).parent().hasClass('expand') || $(this).parent().hasClass('open')) {
                   $(this).parent()
                       .removeClass('expand')
                       .find('.accordion-content').slideUp(200);

                   setTimeout(() => {
                      $(this).parent()
                          .removeClass('open')
                   }, 200)

                } else {
                   $(this).parent()
                       .addClass('expand')
                       .find('> .accordion-content').slideDown(200);

                }
             });
      },
      showOptions: function () {
         parentEle.on('click', '.options-icon',
             function (e) {
                $('.options-sec').removeClass('on');
                $(this).parent().addClass('on');
             });
         parentEle.on('click', '.options-list li',
             function (e) {
                $(this).parents().eq(1).removeClass('on');
             });
      },
      phoneMenu: function () {
         parentEle.on('click', '.header .menuBtn', function (e) {
            let init = $(this).data('init');

            if (init === 0) {
               $('.header').addClass('openMenu');
               $('.headerNav').addClass('openMenu');
               $(this).data({
                  'init': 1,
               }).addClass('open');

            } else {
               $('.header').removeClass('openMenu').removeClass('menuDone');
               $('.headerNav').removeClass('openMenu');
               $(this).data({
                  'init': 0,
               }).removeClass('open');
            }
         });
         parentEle.on('click', '.headerNav .nav', function (e) {
            $('.header').removeClass('openMenu').removeClass('menuDone');
            $('.headerNav').removeClass('openMenu');
            $('.header .menuBtn').data({
               'init': 0,
            }).removeClass('open');
         })
      },
      defaultClick: function () {
         $(document).click(function () {
            $('.drop-down .list, .multiSelect .list').slideUp(200);
            $('.drop-down').removeClass('open');
            $('.options-sec').removeClass('on');
         });
      },
      preventDefaultClicks: function () {
         let selectors = '.drop-down, .options-sec, .headerNav';
         parentEle.on('click', selectors, function (e) {
            e.stopPropagation();
         });
      },
   };
   fun.dropDown();
   fun.accordion();
   fun.showOptions();
   fun.phoneMenu();
   fun.preventDefaultClicks();
   fun.defaultClick();
});
